module.exports = __webpack_public_path__ + "f5f3492232cfd6196a2764887e68f0b6.svg";